module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Files/Media-3d93b7d915520b6b6f692bc5d1dbd6de.svg";